/* eslint-disable */
export const Colors = {
  baseBrand50: "#e8f5fc",
  baseBrand100: "#d1ebf9",
  baseBrand200: "#a3d6f4",
  baseBrand300: "#75c2ee",
  baseBrand400: "#47ade9",
  baseBrand500: "#1999e3",
  baseBrand600: "#147ab6",
  baseBrand700: "#0f5c88",
  baseBrand800: "#0a3d5b",
  baseBrand900: "#051f2d",
  baseSteel50: "#e3e5e8",
  baseSteel100: "#d9dbe0",
  baseSteel200: "#b9bcc4",
  baseSteel300: "#9a9da9",
  baseSteel400: "#7a7e8d",
  baseSteel500: "#5a5f72",
  baseSteel600: "#484c5b",
  baseSteel700: "#363944",
  baseSteel800: "#24262e",
  baseSteel900: "#121317",
  baseGray50: "#fdfdfe",
  baseGray100: "#fafbfc",
  baseGray200: "#f6f8f9",
  baseGray300: "#f1f4f7",
  baseGray400: "#edf1f4",
  baseGray500: "#e8edf1",
  baseGray600: "#c7d0d7",
  baseGray700: "#a6b3bd",
  baseGray800: "#8595a2",
  baseGray900: "#647888",
  baseBlue50: "#e8f5fc",
  baseBlue100: "#d1ebf9",
  baseBlue200: "#a3d6f4",
  baseBlue300: "#75c2ee",
  baseBlue400: "#47ade9",
  baseBlue500: "#1999e3",
  baseBlue600: "#147ab6",
  baseBlue700: "#0f5c88",
  baseBlue800: "#0a3d5b",
  baseBlue900: "#051f2d",
  baseGreen50: "#ebf9ed",
  baseGreen100: "#d8f3db",
  baseGreen200: "#b1e6b7",
  baseGreen300: "#89da92",
  baseGreen400: "#62cd6e",
  baseGreen500: "#1ab616",
  baseGreen600: "#2f9a3b",
  baseGreen700: "#23742c",
  baseGreen800: "#184d1e",
  baseGreen900: "#052404",
  baseRed50: "#fce6e6",
  baseRed100: "#facccc",
  baseRed200: "#f59999",
  baseRed300: "#ef6767",
  baseRed400: "#ea3434",
  baseRed500: "#e50101",
  baseRed600: "#b70101",
  baseRed700: "#890101",
  baseRed800: "#5c0000",
  baseRed900: "#2e0000",
  baseYellow50: "#fdf5e7",
  baseYellow100: "#fcebcf",
  baseYellow200: "#f9d79f",
  baseYellow300: "#f6c26f",
  baseYellow400: "#f3ae3f",
  baseYellow500: "#f09a0f",
  baseYellow600: "#c07b0c",
  baseYellow700: "#905c09",
  baseYellow800: "#603e06",
  baseYellow900: "#301f03",
  interactivePrimaryDefault: "#1999e3",
  interactivePrimaryActive: "#1999e3",
  interactivePrimaryHover: "#147ab6",
  interactivePrimaryPressed: "#0f5c88",
  interactivePrimaryDisabled: "#75c2ee",
  interactiveSuccessDefault: "#1ab616",
  interactiveSuccessHover: "#2f9a3b",
  interactiveSuccessPressed: "#23742c",
  interactiveSuccessActive: "#23742c",
  interactiveSuccessDisabled: "#89da92",
  interactiveWarningDefault: "#f09a0f",
  interactiveWarningHover: "#c07b0c",
  interactiveWarningPressed: "#905c09",
  interactiveWarningDisabled: "#f6c26f",
  interactiveCriticalDefault: "#e50101",
  interactiveCriticalHover: "#b70101",
  interactiveCriticalPressed: "#890101",
  interactiveCriticalDisabled: "#ef6767",
  interactiveInfoDefault: "#1999e3",
  interactiveInfoHover: "#147ab6",
  interactiveInfoPressed: "#0f5c88",
  interactiveInfoDisabled: "#75c2ee",
  interactiveNeutralDefault: "#edf1f4",
  interactiveNeutralHover: "#e8edf1",
  interactiveNeutralPressed: "#c7d0d7",
  interactiveNeutralDisabled: "#a6b3bd",
  backgroundViewDarker: "#e3e5e8",
  backgroundViewHoverBackground: "#e8f5fc",
  backgroundViewLighter: "#fafbfc",
  backgroundViewLight: "#f6f8f9",
  backgroundViewApp: "#f1f4f7",
  backgroundViewHover: "#edf1f4",
  backgroundViewNavi: "#e8edf1",
  backgroundSystemInfoLight: "#e8f5fc",
  backgroundSystemInfoDefault: "#d1ebf9",
  backgroundSystemCritcal: "#facccc",
  backgroundSystemWarning: "#fcebcf",
  backgroundSystemSuccess: "#d8f3db",
  backgroundPrivateDefault: "#FFFFCD",
  backgroundPrivateLight: "#ffffe7",
  backgroundPrivateDark: "#f2f2c3",
  backgroundGradientBrand: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
  backgroundGradientNeutral: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
  backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  backgroundGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
  backgroundGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
  backgroundGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
  backgroundGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
  backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
  backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #D1EBF9, #D1EBF9 6px, #A3D6F4 6px, #A3D6F4 12px)",
  backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  backgroundGradientMask: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
  backgroundGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
  backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
  backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  backgroundGradientTellentPink: "linear-gradient(90deg, #752D81 0%, #FF0096 100%)",
  borderNeutralDefault: "#c7d0d7",
  borderNeutralDark: "#a6b3bd",
  borderNeutralDisabled: "#e8edf1",
  borderNeutralTransparent: "rgba(255,255,255,0.3)",
  borderSystemInfo: "#1999e3",
  borderSystemSuccess: "#1ab616",
  borderSystemCritical: "#e50101",
  borderSystemWarning: "#f09a0f",
  borderMainPrimary: "#1999e3",
  borderMainActive: "#a3d6f4",
  textSystemInfo: "#147ab6",
  textSystemSuccess: "#2f9a3b",
  textSystemWarning: "#c07b0c",
  textSystemCritical: "#b70101",
  textMainDefault: "#121317",
  textMainSubdued: "#5a5f72",
  textMainDisabled: "#9a9da9",
  textMainActive: "#147ab6",
  iconSystemInfo: "#1999e3",
  iconSystemSuccess: "#1ab616",
  iconSystemWarning: "#f09a0f",
  iconSystemCritical: "#e50101",
  iconMainBrand: "#1999e3",
  iconMainDefault: "#121317",
  iconMainSubdued: "#5a5f72",
  iconMainDisabled: "#9a9da9",
  iconMainActive: "#147ab6",
  miscSpecialPersonal: "#f09300",
  miscSpecialViolet: "#7986cb",
  miscSpecialOrange: "#de6603",
  miscSpecialOrangeLight: "#FAE8D9",
  miscSpecialYellow: "#F4BB26",
  miscSpecialIndigo: "#102F7A",
  miscSpecialDarkYellow: "#CCCCA4",
  miscSpecialDarkBlue: "#113883",
  miscSpecialLime: "#9DE000",
  miscSpecialGrayDark: "#5F6E82",
  miscSpecialGrayLight: "#E9EDF3",
  miscSpecialTurquoise: "#00A4AD",
  miscSpecialTurquoiseLight: "#DCF2F4",
  miscSpecialPurple: "#995CE0",
  miscSpecialPurpleLight: "#EAE5FA",
  miscSpecialBrown: "#946A57",
  miscSpecialBrownLight: "#F5F1EF",
  miscSocialFacebook: "#41599c",
  miscSocialTwitter: "#3dacf0",
  miscSocialGooglePlus: "#d34836",
  miscSocialLinkedin: "#2b80b5",
  miscSocialX: "#000000",
  miscPublicDefault: "#31bd95",
  miscPublicHover: "#239E7D",
  miscPublicSubdued: "#EAF8F4",
  pricingScaleDefault: "#31bd95",
  pricingScaleHover: "#1ea275",
  pricingScaleSubdued: "#EAF8F4",
  pricingLeadDefault: "#7148bd",
  pricingLeadHover: "#512fa2",
  pricingLeadSubdued: "#F0ECF8",
  pricingOptimizeDefault: "#7148bd",
  pricingOptimizeHover: "#512fa2",
  pricingOptimizeSubdued: "#F0ECF8",
  pricingGrowDefault: "#1EA275",
  pricingGrowHover: "#03764F",
  pricingGrowSubdued: "#EAF8F4",
  pricingStartDefault: "#121317",
  pricingStartHover: "#24262e",
  white: "#fff",
  black: "#000",
  colorBgDefault: "#fff",
  colorBgHover: "#edf1f4",
  colorBgActive: "#d1ebf9",
  colorBgDisabled: "#c7d0d7",
  colorBgSelected: "#d1ebf9",
  colorBgPrimaryDefault: "#1999e3",
  colorBgPrimaryHover: "#147ab6",
  colorBgPrimaryPressed: "#0f5c88",
  colorBgPrimarySelected: "#1999e3",
  colorBgPrimaryDisabled: "#75c2ee",
  colorBgPrimarySubduedDefault: "#e8f5fc",
  colorBgPrimarySubduedHover: "#e8f5fc",
  colorBgPrimarySubduedSelected: "#e8f5fc",
  colorBgPrimarySubduedActive: "#e8f5fc",
  colorBgPrimaryStrongDefault: "#147ab6",
  colorBgPrimaryLowDefault: "#d1ebf9",
  colorBgPrimaryLowHover: "#d1ebf9",
  colorBgPrimaryLowPressed: "#a3d6f4",
  colorBgNeutralDefault: "#f1f4f7",
  colorBgNeutralHover: "#e8edf1",
  colorBgNeutralPressed: "#c7d0d7",
  colorBgNeutralDisabled: "#a6b3bd",
  colorBgNeutralSelected: "#edf1f4",
  colorBgNeutralLowDefault: "#f6f8f9",
  colorBgNeutralLowHover: "#e3e5e8",
  colorBgNeutralLowDisabled: "#f1f4f7",
  colorBgNeutralStrongDefault: "#c7d0d7",
  colorBgNeutralStrongHover: "#a6b3bd",
  colorBgSuccessDefault: "#1ab616",
  colorBgSuccessHover: "#2f9a3b",
  colorBgSuccessPressed: "#23742c",
  colorBgSuccessDisabled: "#89da92",
  colorBgSuccessLowDefault: "#d8f3db",
  colorBgSuccessLowHover: "#d8f3db",
  colorBgSuccessLowPressed: "#d8f3db",
  colorBgCriticalDefault: "#e50101",
  colorBgCriticalHover: "#b70101",
  colorBgCriticalPressed: "#890101",
  colorBgCriticalDisabled: "#ef6767",
  colorBgCriticalLowDefault: "#facccc",
  colorBgCriticalLowHover: "#facccc",
  colorBgCriticalLowPressed: "#facccc",
  colorBgCriticalStrongDefault: "#b70101",
  colorBgCriticalStrongActive: "#890101",
  colorBgCriticalSubduedDefault: "#fce6e6",
  colorBgWarningDefault: "#f09a0f",
  colorBgWarningHover: "#c07b0c",
  colorBgWarningPressed: "#905c09",
  colorBgWarningDisabled: "#f6c26f",
  colorBgWarningLowDefault: "#fcebcf",
  colorBgWarningLowHover: "#fcebcf",
  colorBgWarningLowPressed: "#fcebcf",
  colorBgScaleDefault: "#31bd95",
  colorBgScaleHover: "#1ea275",
  colorBgScaleSubduedDefault: "#EAF8F4",
  colorBgLeadDefault: "#7148bd",
  colorBgLeadHover: "#512fa2",
  colorBgLeadSubduedDefault: "#F0ECF8",
  colorBgPrivateDefault: "#FFFFCD",
  colorBgPrivateHover: "#f2f2c3",
  colorBgPrivateStrongDefault: "#f2f2c3",
  colorBgPrivateLowDefault: "#ffffe7",
  colorBgGradientSubdued: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
  colorBgSecondaryDefault: "#5a5f72",
  colorBgSecondaryDisabled: "#e3e5e8",
  colorBgSecondaryStrongDefault: "#121317",
  colorBgSecondaryStrongHover: "#363944",
  colorBgSecondaryStrongPressed: "#484c5b",
  colorBgSecondaryStrongActive: "#24262e",
  colorBgSecondarySubduedDefault: "#d9dbe0",
  colorBgSecondaryLowDefault: "#7a7e8d",
  colorBgSecondaryLowDisabled: "#9a9da9",
  colorBgInfoDefault: "#1999e3",
  colorBgInfoHover: "#147ab6",
  colorBgInfoPressed: "#0f5c88",
  colorBgInfoDisabled: "#75c2ee",
  colorBgInfoStrongDefault: "#147ab6",
  colorBgInfoLowDefault: "#d1ebf9",
  colorBgInfoLowHover: "#d1ebf9",
  colorBgInfoLowPressed: "#d1ebf9",
  colorBgOverdueDefault: "#de6603",
  colorBgOverdueLowDefault: "#FAE8D9",
  colorBgNoconsentDefault: "#FAE8D9",
  colorBgNodataDefault: "#FAE8D9",
  colorBgTeamDefault: "#7986cb",
  colorBgPersonalDefault: "#f09300",
  colorBgOverlayDefault: "rgba(36,38,46,0.7)",
  colorBgOnoverlayHover: "rgba(255,255,255,0.1)",
  colorBgOnoverlayPressed: "rgba(255,255,255,0.2)",
  colorBgGhostHover: "rgba(255,255,255,0.1)",
  colorBgGhostPressed: "rgba(255,255,255,0.2)",
  colorBgTintDefault: "rgba(255,255,255,0.3)",
  colorBgLoadingDefault: "rgba(255,255,255,0.15)",
  colorBgOfferDefault: "#995CE0",
  colorBgOfferHover: "#7D43C3",
  colorBgOfferPressed: "#602D9F",
  colorBgOfferLowDefault: "#EAE5FA",
  colorBgOfferLowHover: "#EAE5FA",
  colorBgScreeningDefault: "#147ab6",
  colorBgScreeningHover: "#0f5c88",
  colorBgScreeningPressed: "#0a3d5b",
  colorBgScreeningLowDefault: "#d1ebf9",
  colorBgInterviewDefault: "#1999e3",
  colorBgInterviewHover: "#147ab6",
  colorBgInterviewPressed: "#0f5c88",
  colorBgInterviewLowDefault: "#d1ebf9",
  colorBgEvaluationDefault: "#00A4AD",
  colorBgEvaluationHover: "#00858C",
  colorBgEvaluationPressed: "#006A70",
  colorBgEvaluationLowDefault: "#DCF2F4",
  colorBgEvaluationLowHover: "#DCF2F4",
  colorBgHiredDefault: "#1ab616",
  colorBgHiredHover: "#2f9a3b",
  colorBgHiredPressed: "#23742c",
  colorBgHiredLowDefault: "#d8f3db",
  colorBgTranslateDefault: "#f09a0f",
  colorBgChartDefault: "rgba(25, 153, 227, 0.1)",
  colorBgVersatileSecondaryStrongDefault: "#121317",
  colorBgVersatileSecondaryStrongHover: "#363944",
  colorBgVersatileSecondaryStrongPressed: "#484c5b",
  colorBgVersatileSecondaryStrongActive: "#24262e",
  colorBgVersatileSecondaryDefault: "#5a5f72",
  colorBgVersatileSecondaryHover: "#484C5B",
  colorBgVersatileSecondaryMediumDefault: "#363944",
  colorBgVersatileSecondaryMediumHover: "#484c5b",
  colorBgVersatileSecondaryMediumActive: "#5a5f72",
  colorBgSkeletonDefault: "#ecf0f4",
  colorBgOncomponentDefault: "#fff",
  colorBgOncomponentHover: "#fff",
  colorBgOncomponentActive: "#fff",
  colorBgOptimizeDefault: "#7148bd",
  colorBgOptimizeHover: "#512fa2",
  colorBgOptimizeSubduedDefault: "#F0ECF8",
  colorBgGrowDefault: "#1EA275",
  colorBgGrowHover: "#03764F",
  colorBgGrowSubduedDefault: "#EAF8F4",
  colorBgStartDefault: "#121317",
  colorBgStartHover: "#24262e",
  colorBgOnboardingDefault: "#752D81",
  colorBgOnboardingHover: "#752D81",
  colorBgOnboardingLowDefault: "#E7D1EB",
  colorBgOnboardingSubduedDefault: "#F2E7F4",
  colorBgTellentDefault: "#E83393",
  colorBgTellentHover: "#CC287F",
  colorBgTellentPressed: "#951B5C",
  colorBgTellentActive: "#FCE3F0",
  colorBgAppliedDefault: "#5F6E82",
  colorBgAppliedHover: "#4B5767",
  colorBgAppliedPressed: "#3A4655",
  colorBgAppliedLowDefault: "#E9EDF3",
  colorBgNotypeDefault: "#946A57",
  colorBgNotypeHover: "#7C5442",
  colorBgNotypePressed: "#5F3E30",
  colorBgNotypeLowDefault: "#F5F1EF",
  colorBgKiwiDefault: "#007838",
  colorBgKiwiHover: "#D9EBE1",
  colorBgJaveloDefault: "#D14905",
  colorBgJaveloHover: "#F8E4DA",
  colorBgRecruiteeDefault: "#1999e3",
  colorBgPublicSubduedDefault: "#EAF8F4",
  colorTextDefault: "#5a5f72",
  colorTextHover: "#121317",
  colorTextPressed: "#121317",
  colorTextDisabled: "#9a9da9",
  colorTextActive: "#147ab6",
  colorTextStrongDefault: "#121317",
  colorTextStrongHover: "#121317",
  colorTextStrongSelected: "#121317",
  colorTextLowDefault: "#7a7e8d",
  colorTextOnprimaryDefault: "#fff",
  colorTextOnprimaryHover: "#fff",
  colorTextOnprimaryPressed: "#fff",
  colorTextOnprimaryDisabled: "#fff",
  colorTextOnprimarySelected: "#fff",
  colorTextOnneutralDisabled: "#fff",
  colorTextOnsuccessDefault: "#fff",
  colorTextOnsuccessHover: "#fff",
  colorTextOnsuccessPressed: "#fff",
  colorTextOncriticalDefault: "#fff",
  colorTextOncriticalHover: "#fff",
  colorTextOncriticalPressed: "#fff",
  colorTextOnwarningDefault: "#fff",
  colorTextOnwarningHover: "#fff",
  colorTextOnwarningPressed: "#fff",
  colorTextSuccessDefault: "#1ab616",
  colorTextSuccessHover: "#1ab616",
  colorTextSuccessPressed: "#2f9a3b",
  colorTextSuccessStrongDefault: "#2f9a3b",
  colorTextCriticalDefault: "#e50101",
  colorTextCriticalHover: "#e50101",
  colorTextCriticalPressed: "#b70101",
  colorTextCriticalStrongDefault: "#b70101",
  colorTextInfoDefault: "#1999e3",
  colorTextInfoHover: "#1999e3",
  colorTextInfoPressed: "#147ab6",
  colorTextInfoStrongDefault: "#147ab6",
  colorTextWarningDefault: "#f09a0f",
  colorTextWarningHover: "#f09a0f",
  colorTextWarningPressed: "#c07b0c",
  colorTextWarningStrongDefault: "#c07b0c",
  colorTextOnscaleDefault: "#fff",
  colorTextOnscaleHover: "#fff",
  colorTextOnleadDefault: "#fff",
  colorTextOnleadHover: "#fff",
  colorTextScaleDefault: "#31bd95",
  colorTextScaleHover: "#1ea275",
  colorTextOngradientDefault: "#fff",
  colorTextLeadDefault: "#7148bd",
  colorTextOnsecondaryDefault: "#fff",
  colorTextOnsecondaryStrongDefault: "#fff",
  colorTextOnsecondaryStrongHover: "#fff",
  colorTextOnsecondaryStrongPressed: "#fff",
  colorTextOninfoStrongDefault: "#fff",
  colorTextOninfoDefault: "#fff",
  colorTextOninfoHover: "#fff",
  colorTextOninfoPressed: "#fff",
  colorTextOverdueDefault: "#de6603",
  colorTextOnoverdueDefault: "#fff",
  colorTextNoconsentDefault: "#de6603",
  colorTextNodataDefault: "#de6603",
  colorTextOnoverlayDefault: "#fff",
  colorTextOnoverlayHover: "#fff",
  colorTextOnoverlayPressed: "#fff",
  colorTextOnoverlayDisabled: "#7a7e8d",
  colorTextOnoverlayLowDefault: "#e8edf1",
  colorTextOnghostDefault: "#fff",
  colorTextOnghostHover: "#fff",
  colorTextOnghostPressed: "#fff",
  colorTextOnghostDisabled: "#7a7e8d",
  colorTextPrimaryDefault: "#1999e3",
  colorTextPrimaryActive: "#1999e3",
  colorTextPrimaryHover: "#147ab6",
  colorTextPrimaryPressed: "#147ab6",
  colorTextPrimaryStrongDefault: "#147ab6",
  colorTextPrimaryStrongActive: "#147ab6",
  colorTextOnteamDefault: "#fff",
  colorTextOncomponentDefault: "#fff",
  colorTextOnoptimizeDefault: "#fff",
  colorTextOnoptimizeHover: "#fff",
  colorTextOptimizeDefault: "#7148bd",
  colorTextOptimizeHover: "#512fa2",
  colorTextOngrowDefault: "#fff",
  colorTextOngrowHover: "#fff",
  colorTextGrowDefault: "#1EA275",
  colorTextGrowHover: "#03764F",
  colorTextOnstartDefault: "#fff",
  colorTextOnstartHover: "#fff",
  colorTextOnboardingLowDefault: "#E7D1EB",
  colorTextOnboardingDefault: "#2B002B",
  colorTextOnonboardingDefault: "#fff",
  colorTextOnonboardingHover: "#fff",
  colorTextOntellentDefault: "#fff",
  colorTextOntellentHover: "#fff",
  colorTextOntellentPressed: "#fff",
  colorTextOnappliedDefault: "#fff",
  colorTextOnappliedHover: "#fff",
  colorTextOnappliedPressed: "#fff",
  colorTextOnscreeningDefault: "#fff",
  colorTextOnscreeningHover: "#fff",
  colorTextOnscreeningPressed: "#fff",
  colorTextOninterviewDefault: "#fff",
  colorTextOninterviewHover: "#fff",
  colorTextOninterviewPressed: "#fff",
  colorTextOnevaluationDefault: "#fff",
  colorTextOnevaluationHover: "#fff",
  colorTextOnevaluationPressed: "#fff",
  colorTextOnofferDefault: "#fff",
  colorTextOnofferHover: "#fff",
  colorTextOnofferPressed: "#fff",
  colorTextOnhiredDefault: "#fff",
  colorTextOnhiredHover: "#fff",
  colorTextOnhiredPressed: "#fff",
  colorTextOnnotypeDefault: "#fff",
  colorTextOnnotypeHover: "#fff",
  colorTextOnnotypePressed: "#fff",
  colorTextOnkiwiDefault: "#fff",
  colorTextOnjaveloDefault: "#fff",
  colorTextOnrecruiteeDefault: "#fff",
  colorTextRecruiteeDefault: "#1999e3",
  colorTextRecruiteeStrongDefault: "#147ab6",
  colorTextKiwiStrongDefault: "#007838",
  colorTextKiwiDefault: "#007838",
  colorIconDefault: "#5a5f72",
  colorIconHover: "#121317",
  colorIconPressed: "#121317",
  colorIconDisabled: "#9a9da9",
  colorIconActive: "#147ab6",
  colorIconStrongDefault: "#121317",
  colorIconOnprimaryDefault: "#fff",
  colorIconOnprimaryHover: "#fff",
  colorIconOnprimaryPressed: "#fff",
  colorIconOnprimaryDisabled: "#fff",
  colorIconOnneutralDisabled: "#fff",
  colorIconOnsuccessDefault: "#fff",
  colorIconOnsuccessHover: "#fff",
  colorIconOnsuccessPressed: "#fff",
  colorIconOnsuccessDisabled: "#fff",
  colorIconOncriticalDefault: "#fff",
  colorIconOncriticalHover: "#fff",
  colorIconOncriticalPressed: "#fff",
  colorIconOnwarningDefault: "#fff",
  colorIconOnwarningHover: "#fff",
  colorIconOnwarningPressed: "#fff",
  colorIconSuccessDefault: "#1ab616",
  colorIconSuccessHover: "#1ab616",
  colorIconSuccessPressed: "#2f9a3b",
  colorIconSuccessActive: "#23742c",
  colorIconSuccessStrongDefault: "#2f9a3b",
  colorIconCriticalDefault: "#e50101",
  colorIconCriticalHover: "#e50101",
  colorIconCriticalPressed: "#b70101",
  colorIconCriticalStrongDefault: "#b70101",
  colorIconCriticalStrongHover: "#b70101",
  colorIconInfoDefault: "#1999e3",
  colorIconInfoHover: "#1999e3",
  colorIconInfoPressed: "#147ab6",
  colorIconInfoStrongDefault: "#147ab6",
  colorIconWarningDefault: "#f09a0f",
  colorIconWarningHover: "#f09a0f",
  colorIconWarningPressed: "#c07b0c",
  colorIconWarningStrongDefault: "#c07b0c",
  colorIconScaleDefault: "#31bd95",
  colorIconScaleHover: "#1ea275",
  colorIconOngradientDefault: "#fff",
  colorIconOnscaleDefault: "#fff",
  colorIconOnscaleHover: "#fff",
  colorIconLeadDefault: "#7148bd",
  colorIconOnleadDefault: "#fff",
  colorIconOnleadHover: "#fff",
  colorIconOnsecondaryDefault: "#fff",
  colorIconOnsecondaryStrongDefault: "#fff",
  colorIconOnsecondaryStrongHover: "#fff",
  colorIconOninfoStrongDefault: "#fff",
  colorIconOninfoDefault: "#fff",
  colorIconOninfoHover: "#fff",
  colorIconOninfoPressed: "#fff",
  colorIconOverdueDefault: "#de6603",
  colorIconOnoverdueDefault: "#fff",
  colorIconNoconsentDefault: "#de6603",
  colorIconNodataDefault: "#de6603",
  colorIconOnoverlayDefault: "#fff",
  colorIconOnoverlayHover: "#fff",
  colorIconOnoverlayPressed: "#fff",
  colorIconOnoverlayDisabled: "#7a7e8d",
  colorIconOnghostDefault: "#fff",
  colorIconOnghostHover: "#fff",
  colorIconOnghostPressed: "#fff",
  colorIconOnghostDisabled: "#7a7e8d",
  colorIconPrimaryDefault: "#1999e3",
  colorIconPrimaryHover: "#147ab6",
  colorIconPrimaryPressed: "#1999e3",
  colorIconPrimaryStrongDefault: "#147ab6",
  colorIconPrimaryStrongPressed: "#147ab6",
  colorIconLowDefault: "#7a7e8d",
  colorIconLowHover: "#5a5f72",
  colorIconLowDisabled: "#a6b3bd",
  colorIconSubduedDefault: "#d9dbe0",
  colorIconOncomponentDefault: "#fff",
  colorIconAiDefault: "#6F52E2",
  colorIconTranslateDefault: "#f09a0f",
  colorIconOptimizeDefault: "#7148bd",
  colorIconOptimizeHover: "#512fa2",
  colorIconOnoptimizeDefault: "#fff",
  colorIconOnoptimizeHover: "#fff",
  colorIconGrowDefault: "#1EA275",
  colorIconGrowHover: "#03764F",
  colorIconOngrowDefault: "#fff",
  colorIconOngrowHover: "#fff",
  colorIconOnboardingDefault: "#752D81",
  colorIconOnboardingLowDefault: "#E7D1EB",
  colorIconOnonboardingDefault: "#fff",
  colorIconOnonboardingHover: "#fff",
  colorIconOnhiredDefault: "#fff",
  colorIconOnhiredHover: "#fff",
  colorIconOnhiredPressed: "#fff",
  colorIconOnkiwiDefault: "#fff",
  colorIconOnjaveloDefault: "#fff",
  colorIconOnappliedDefault: "#fff",
  colorIconOnappliedHover: "#fff",
  colorIconOnappliedPressed: "#fff",
  colorIconOnscreeningDefault: "#fff",
  colorIconOnscreeningHover: "#fff",
  colorIconOnscreeningPressed: "#fff",
  colorIconOninterviewDefault: "#fff",
  colorIconOninterviewHover: "#fff",
  colorIconOninterviewPressed: "#fff",
  colorIconOnevaluationDefault: "#fff",
  colorIconOnevaluationHover: "#fff",
  colorIconOnevaluationPressed: "#fff",
  colorIconOnofferDefault: "#fff",
  colorIconOnofferHover: "#fff",
  colorIconOnofferPressed: "#fff",
  colorIconOnnotypeDefault: "#fff",
  colorIconOnnotypeHover: "#fff",
  colorIconOnnotypePressed: "#fff",
  colorIconOntellentDefault: "#fff",
  colorIconOntellentHover: "#fff",
  colorIconOntellentPressed: "#fff",
  colorIconTellentDefault: "#E83393",
  colorIconTellentActive: "#E83393",
  colorIconOfferDefault: "#995CE0",
  colorIconEvaluationDefault: "#00A4AD",
  colorIconPublicDefault: "#31bd95",
  colorIconRecruiteeDefault: "#1999e3",
  colorIconKiwiDefault: "#007838",
  colorBorderDefault: "#c7d0d7",
  colorBorderHover: "#c7d0d7",
  colorBorderPressed: "#c7d0d7",
  colorBorderDisabled: "#e8edf1",
  colorBorderSelected: "#c7d0d7",
  colorBorderActive: "#a3d6f4",
  colorBorderSuccessDefault: "#1ab616",
  colorBorderSuccessHover: "#1ab616",
  colorBorderSuccessPressed: "#2f9a3b",
  colorBorderSuccessSubduedDefault: "#b1e6b7",
  colorBorderSuccessLowDefault: "#62cd6e",
  colorBorderCriticalDefault: "#e50101",
  colorBorderCriticalHover: "#e50101",
  colorBorderCriticalPressed: "#b70101",
  colorBorderCriticalLowDefault: "#ef6767",
  colorBorderCriticalSubduedDefault: "#f59999",
  colorBorderInfoDefault: "#1999e3",
  colorBorderInfoHover: "#1999e3",
  colorBorderInfoPressed: "#147ab6",
  colorBorderInfoSubduedDefault: "#a3d6f4",
  colorBorderWarningDefault: "#f09a0f",
  colorBorderWarningHover: "#f09a0f",
  colorBorderWarningPressed: "#c07b0c",
  colorBorderWarningDisabled: "#f6c26f",
  colorBorderWarningSubduedDefault: "#f9d79f",
  colorBorderNeutralHover: "#a6b3bd",
  colorBorderNeutralDisabled: "#f1f4f7",
  colorBorderOncomponentDefault: "#fff",
  colorBorderSecondaryDefault: "#5a5f72",
  colorBorderSecondaryHover: "#121317",
  colorBorderSecondaryDisabled: "#9a9da9",
  colorBorderSecondaryLowDefault: "#7a7e8d",
  colorBorderSecondaryLowDisabled: "#b9bcc4",
  colorBorderSecondaryStrongDefault: "#363944",
  colorBorderPrimaryDefault: "#1999e3",
  colorBorderPrimaryHover: "#147ab6",
  colorBorderPrimaryStrongDefault: "#147ab6",
  colorBorderPrimarySubduedDefault: "#a3d6f4",
  colorBorderPrimaryLowDefault: "#47ade9",
  colorBorderTranslateDefault: "#f09a0f",
  colorBorderOnghostDefault: "#fff",
  colorBorderOnghostHover: "#fff",
  colorBorderOnghostPressed: "#fff",
  colorBorderOnghostDisabled: "#7a7e8d",
  colorBorderPrivateDefault: "#CCCCA4",
  colorBorderStrongDefault: "#a6b3bd",
  colorBorderStrongDisabled: "#a6b3bd",
  colorBorderLowDefault: "#e8edf1",
  colorBorderLowHover: "#d9dbe0",
  colorBorderTeamDefault: "#7986cb",
  colorBorderVersatileSecondaryDefault: "#5a5f72",
  colorBorderTintDefault: "rgba(255,255,255,0.3)",
  colorGradientPrimary: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
  colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  colorGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
  colorGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
  colorGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
  colorGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
  colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  colorGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
  colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #D1EBF9, #D1EBF9 6px, #A3D6F4 6px, #A3D6F4 12px)",
  colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  colorGradientTruncate: "#FFFFFF00",
  colorGradientShimmer: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
  colorGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
  colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
  colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  colorGradientPink: "linear-gradient(90deg, #752D81 0%, #FF0096 100%)",
  colorTooltipFeature: "#113883",
  colorTooltipFeatureLight: "#198FD9",
  colorAvatarSteelLighter: "#e3e5e8",
  colorAvatarSteelLight: "#d9dbe0",
  colorAvatarSteelDark: "#5a5f72",
  colorAvatarGrayLight: "#c7d0d7",
  colorAvatarGrayDark: "#647888",
  colorAvatarGreen: "#1ea275",
  colorAvatarBlueLight: "#1999e3",
  colorAvatarBlueDark: "#147ab6",
  colorAvatarBlueDarker: "#0a3d5b",
  colorAvatarPink: "#9A4CB6",
  colorAvatarPurple: "#512fa2",
  colorAvatarYellow: "#f09a0f",
  colorAvatarOrange: "#de6603",
  colorAvatarSkeleton: "#edf1f4",
  colorChartPrimaryDefault: "#1999E3",
  colorChartBlueDefault: "#BAE1F7",
  colorChartTurquoiseDefault: "#4FC0CC",
  colorChartPurpleDefault: "#7148BD",
  colorChartPurpleSubduedDefault: "#AF7EE6",
  colorChartGrayDefault: "#758DA2",
  colorChartGreenDefault: "#7DD47A",
  colorChartGreenSubduedDefault: "#BAF0B7",
  colorChartGraySubduedDefault: "#93A6B7",
  colorChartYellowDefault: "#F4BB26",
  colorChartYellowSubduedDefault: "#FBE54B",
  colorChartGrayStrongDefault: "#4D6072",
  colorSeparatorTransparent: "rgba(255,255,255,0.3)",
  colorLogoTypography: "#131C24",
  colorCandidatesBgPrimaryDefault: "#1999E3",
  colorCandidatesBgGreenStrongDefault: "#1EA275",
  colorCandidatesBgOrangeDefault: "#DE6603",
  colorCandidatesBgYellowDefault: "#F4BB26",
  colorCandidatesBgGreenSubduedDefault: "#31BD95",
  colorCandidatesBgBlueDefault: "#0C6090",
  colorCandidatesBgVioletDefault: "#512FA2",
  colorCandidatesBgGreenDefault: "#4FC510",
  colorCandidatesBgBlueStrongDefault: "#083F5E",
  colorCandidatesBgPurpleDefault: "#9A4CB6",
  colorCandidatesBorderPrimaryDefault: "#1999E3",
  colorCandidatesBorderGreenStrongDefault: "#1EA275",
  colorCandidatesBorderOrangeDefault: "#DE6603",
  colorCandidatesBorderYellowDefault: "#F4BB26",
  colorCandidatesBorderGreenSubduedDefault: "#31BD95",
  colorCandidatesBorderBlueDefault: "#0C6090",
  colorCandidatesBorderVioletDefault: "#512FA2",
  colorCandidatesBorderGreenDefault: "#4FC510",
  colorCandidatesBorderBlueStrongDefault: "#083F5E",
  colorCandidatesBorderPurpleDefault: "#9A4CB6",
  colorScrollbarThumbDefault: "#c7c7c7",
  colorScrollbarThumbHover: "#878787",
  colorScrollbarTrackDefault: "#fafafa",
  colorMarketplaceLogo: "#F1F4F7",
  colorMarketplaceRibbon: "#23742c",
  colorVersatileDefault: "#fff",
  tellentShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(232,51,147,0.2)","type":"dropShadow"}],
  kiwiShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,120,56,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(232,51,147,0.2)","type":"dropShadow"}],
  kiwiShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(0,120,56,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(232,51,147,1)","type":"dropShadow"}],
  kiwiShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,120,56,1)","type":"dropShadow"}],
  avatarSteelLighter: "#e3e5e8",
  avatarSteelLight: "#d9dbe0",
  avatarSteelDark: "#5a5f72",
  avatarGrayLight: "#c7d0d7",
  avatarGrayDark: "#647888",
  avatarGreen: "#1ea275",
  avatarBlueLight: "#1999e3",
  avatarBlueDark: "#147ab6",
  avatarBlueDarker: "#0a3d5b",
  avatarPink: "#9A4CB6",
  avatarPurple: "#512fa2",
  avatarYellow: "#f09a0f",
  avatarOrange: "#de6603",
  avatarSkeleton: "#edf1f4",
  chartBrandDefault: "#1999E3",
  chartSkyDefault: "#BAE1F7",
  chartOceanDefault: "#4FC0CC",
  chartOrchidDefault: "#7148BD",
  chartLavenderDefault: "#AF7EE6",
  chartSteelDefault: "#758DA2",
  chartEmeraldDefault: "#7DD47A",
  chartMintDefault: "#BAF0B7",
  chartSmokeDefault: "#93A6B7",
  chartSunflowerDefault: "#F4BB26",
  chartLemonDefault: "#FBE54B",
  chartGraphiteDefault: "#4D6072",
  candidatesBgBrandDefault: "#1999E3",
  candidatesBgRainforestDefault: "#1EA275",
  candidatesBgFireDefault: "#DE6603",
  candidatesBgGoldDefault: "#F4BB26",
  candidatesBgJungleDefault: "#31BD95",
  candidatesBgNavyDefault: "#0C6090",
  candidatesBgEggplantDefault: "#512FA2",
  candidatesBgGrassDefault: "#4FC510",
  candidatesBgDenimDefault: "#083F5E",
  candidatesBgLilacDefault: "#9A4CB6",
  candidatesBorderBrandDefault: "#1999E3",
  candidatesBorderRainforestDefault: "#1EA275",
  candidatesBorderFireDefault: "#DE6603",
  candidatesBorderGoldDefault: "#F4BB26",
  candidatesBorderJungleDefault: "#31BD95",
  candidatesBorderNavyDefault: "#0C6090",
  candidatesBorderEggplantDefault: "#512FA2",
  candidatesBorderGrassDefault: "#4FC510",
  candidatesBorderDenimDefault: "#083F5E",
  candidatesBorderLilacDefault: "#9A4CB6",
  aiDefault: "#6F52E2",
  productRecruitee50: "#e8f5fc",
  productRecruitee100: "#d1ebf9",
  productRecruitee200: "#a3d6f4",
  productRecruitee300: "#75c2ee",
  productRecruitee400: "#47ade9",
  productRecruitee500: "#1999e3",
  productRecruitee600: "#147ab6",
  productRecruitee700: "#0f5c88",
  productRecruitee800: "#0a3d5b",
  productRecruitee900: "#051f2d",
  productKiwi50: "#F8FFFB",
  productKiwi100: "#D9EBE1",
  productKiwi200: "#95C9AD",
  productKiwi300: "#63AE86",
  productKiwi400: "#32935F",
  productKiwi500: "#007838",
  productKiwi600: "#00602D",
  productKiwi700: "#004822",
  productKiwi800: "#003016",
  productKiwi900: "#002411",
  productJavelo50: "#fff5f0",
  productJavelo100: "#F8E4DA",
  productJavelo200: "#ECAA89",
  productJavelo300: "#E38A5D",
  productJavelo400: "#DA6931",
  productJavelo500: "#D14905",
  productJavelo600: "#A73A04",
  productJavelo700: "#7D2C03",
  productJavelo800: "#541D02",
  productJavelo900: "#3F1602",
  productTellent50: "#FDEBF4",
  productTellent100: "#FCE3F0",
  productTellent200: "#F6B3D7",
  productTellent300: "#EF73B5",
  productTellent400: "#EC53A4",
  productTellent500: "#E83393",
  productTellent600: "#CC287F",
  productTellent700: "#951B5C",
  productTellent800: "#5E0B37",
  productTellent900: "#420027",
  onboardingBackgroundDefault: "#752D81",
  onboardingBackgroundLow: "#E7D1EB",
  onboardingBackgroundSubdued: "#F2E7F4",
  onboardingTextDefault: "#2B002B",
  onboardingTextLow: "#E7D1EB",
  onboardingIconDefault: "#752D81",
  onboardingIconLow: "#E7D1EB",
};
